function setApplyInputLimit($inp, openAvail, amtDue) {
    const max = Math.min(openAvail, amtDue);
    $inp.attr('data-mgr-apply-max', max > 0 ? String(max) : '0');
    $inp.removeAttr('max');
}

function capApplyInput($inp, openAvail, amtDue) {
    const max = Math.min(openAvail, amtDue);
    const raw = String($inp.val() ?? '').replace(/,/g, '').trim();
    const cur = parseFloat(raw);
    const hasValue = raw !== '' && Number.isFinite(cur);

    if (hasValue && cur > max + 0.0001) {
        $inp.val(max > 0 ? max.toFixed(2) : '');
    } else if (hasValue && max <= 0) {
        $inp.val('');
    }
    $inp.attr('max', max);
}

function autofillMaxIfEmpty($inp, openAvail, amtDue) {
    const hasNoValue = $inp.val() === '' || $inp.val() === null;
    if (!hasNoValue) {
        return;
    }
    const defaultApplyAmount = Math.min(amtDue, openAvail);
    if (defaultApplyAmount > 0) {
        $inp.val(defaultApplyAmount.toFixed(2));
    }
}

export { autofillMaxIfEmpty, capApplyInput, setApplyInputLimit };
